import { env } from "configs/EnvironmentConfig";
import { errorMessage } from "helpers/utils";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { removeUserInfo } from "store/actions";
import { postSocialLogin } from "../../../helpers/fakebackend_helper";
//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import authService from "../../../services/authenService";
import {
  apiError,
  changePasswordFail,
  changePasswordSuccess,
  loginSuccess,
} from "./actions";
// Login Redux States
import {
  AUTH_TOKEN,
  BU_STORE_HEADER,
  BU_TENANT_HEADER,
  CHANGE_PASSWORD,
  FORCE_CHANGE_PASS,
  LOGIN_USER,
  LOGOUT_USER,
  SOCIAL_LOGIN,
  TENANT_CODE_HEADER,
  USER_INFO,
} from "./actionTypes";
function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(authService.loginUser, {
      username: user.email,
      password: user.password,
      rememberMe: true,
    });
    localStorage.setItem(AUTH_TOKEN, response.id_token);
    const responseFinalAuth = yield call(authService.getFinalAuth, {
      appCode: env.API_APPCODE,
    });
    if (responseFinalAuth) {
      localStorage.setItem(AUTH_TOKEN, responseFinalAuth.id_token);
      localStorage.setItem(USER_INFO, JSON.stringify({ userName: user.email }));
      // Force-change-password
      if (response?.password_policy?.force_change) {
        history.push("/change-password");
        localStorage.setItem(FORCE_CHANGE_PASS, "true");
      } else {
        history.push("/dashboard");
      }

      yield put(loginSuccess());
    } else {
      localStorage.removeItem(AUTH_TOKEN);
      yield put(apiError("Vui lòng kiểm tra thông tin đăng nhập thất bại"));
    }
  } catch (error) {
    console.log("error", errorMessage(error));
    yield put(apiError("Vui lòng kiểm tra thông tin đăng nhập thất bại"));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUserdevGuardian");
    localStorage.removeItem("authUserprodGuardian");
    localStorage.removeItem(USER_INFO);
    localStorage.removeItem(TENANT_CODE_HEADER);
    localStorage.removeItem(BU_TENANT_HEADER);
    localStorage.removeItem(BU_STORE_HEADER);
    yield put(removeUserInfo());
    window.location.href = "/login";
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchChangePassWord({ passwordOld, passwordNew }) {
  try {
    // Call api
    const data = {
      email: JSON.parse(localStorage.getItem(USER_INFO))?.userName,
      passwordOld,
      passwordNew,
    };
    const response = yield call(authService.changePassword, data);
    if (response && response.result) {
      localStorage.removeItem(FORCE_CHANGE_PASS);
      yield put(changePasswordSuccess());
    } else {
      yield put(changePasswordFail(response?.error));
    }
  } catch (error) {
    yield put(changePasswordFail(error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, data, type);
      localStorage.setItem(AUTH_TOKEN, JSON.stringify(response));
      yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      localStorage.setItem(AUTH_TOKEN, JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    history.push("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeEvery(CHANGE_PASSWORD, fetchChangePassWord);
}

export default authSaga;
